import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { getAuth } from '@angular/fire/auth';

@Injectable({
  providedIn: 'root'
})
export class SecureInnerPagesGuard implements CanActivate {
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot):
    | Promise<boolean | UrlTree>
    | boolean | UrlTree {

    const auth = getAuth();

    // Wait for Firebase to finish restoring the session from persistence
    // before deciding whether the user is logged in. This prevents the guard
    // from redirecting to /login during a page reload while Firebase is still
    // initialising (e.g. after an OAuth redirect back to the app).
    return (auth as any).authStateReady().then(() => {
      const user = auth.currentUser;
      if (user) {
        if (!user.emailVerified) {
          this.router.navigate(['verify-email']);
          return false;
        }
        return true;
      }
      this.router.navigate(['login']);
      return false;
    });
  }

  constructor(
    public router: Router
  ) { }
}
